import { Show, useTranslate } from "react-admin"
import InvoiceShowActions from "./InvoiceShowActions"
import InvoiceLayout from "./InvoiceLayout"

const InvoiceShow = () => {

  const translate = useTranslate()
  
  return (
    <Show actions={<InvoiceShowActions />} title={translate("resources.invoices.name", {smart_count: 1})}>
      <InvoiceLayout resource="invoices" isPreview={false} />
    </Show>
  )
}

export default InvoiceShow